<template>
  <div class="voice-recording-anchor">
    <div class="title">语音文件列表</div>
    <el-anchor>
      <el-anchor-link v-for="link in list" :key="link.uid" :href="`#${link.uid}`" @click="handleLink(link)">
        {{ link.name }}
      </el-anchor-link>
    </el-anchor>
  </div>
</template>

<script setup>

const props = defineProps({
  list: {
    type: Array,
    default: () => []
  }
})

const emits = defineEmits(['change-anchor'])

const handleLink = (link) => {
  emits('change-anchor', link.uid)
}

</script>

<style lang="scss" scoped>
.voice-recording-anchor {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  .title {
    white-space: nowrap;
  }
  :deep(.el-anchor) {
    margin-top: 20px;
    .el-anchor__marker {
      width: 2px !important;
      height: 36px !important;
      border-radius: 0;
    }
    .el-anchor__list {
      padding-left: 0;
      .el-anchor__item {
        padding-left: 14px;
        border-left: 1px solid #EEE;
      }
      .el-anchor__link {
        padding: 6px 0;
        font-size: 14px;
        color: #222;
        &.is-active {
          color: var(--el-color-primary);
        }
      }
    }
  }
}
</style>